/**
 * Форматирует числовую ставку для отображения в интерфейсе (ru-RU, до одного знака после запятой).
 */
export function formatRate(value: number | undefined): string {
  const safeValue = typeof value === 'number' ? value : 0;

  return safeValue.toLocaleString('ru-RU', { maximumFractionDigits: 1, minimumFractionDigits: 0 });
}
